import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { convertPetRewardListFromStrings, useMixins } from '@/modules/picword/pet/model/mixins';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { picwordService } from '@/services/picword';

export function usePicwordPetDetail() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { model } = useMixins();

    const fetch = crudAction.executeAction({
        request: () => picwordService.pet.get(model.id),
        onSuccess: ({ data }) => {
            model.rewardList = convertPetRewardListFromStrings(
                data.experienceByLevel,
                data.creditReward,
                data.heartReward,
                data.boosterReward
            );

            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_PICWORD.PET.INDEX })
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: () => picwordService.pet.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_PICWORD.PET.INDEX })
        })
    };

    return { model, fetch, actions };
}
